export default "__VITE_ASSET__o2JkBnzZ__"